import { render } from "./IssuerEdit.vue?vue&type=template&id=03a2224a"
import script from "./IssuerEdit.vue?vue&type=script&lang=js"
export * from "./IssuerEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__